import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { ThemeState } from '../interfaces/theme';

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      isDarkMode: false,
      setDarkMode: (isDark) => set({ isDarkMode: isDark }),
      toggleDarkMode: () => set((state) => ({ isDarkMode: !state.isDarkMode })),
      initialize: async () => {
        return new Promise<void>((resolve) => {
          const prefersDark = typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches;
          set({ isDarkMode: prefersDark });
          resolve();
        });
      },
      toggleTheme: () => set((state) => ({ isDarkMode: !state.isDarkMode })),
    }),
    {
      name: 'theme-storage',
      storage: createJSONStorage(() => {
        // Use different storage depending on platform
        const isServer = typeof window === 'undefined';
        if (isServer) return { getItem: () => null, setItem: () => {}, removeItem: () => {} };
        return localStorage;
      }),
    }
  )
); 